import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'
import ContractsImage from '../../assets/icons/contracts-large'
import './index.scss'
import { useNavigate } from 'react-router-dom'

const NoContractOverlay = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <div
      className='no-contracts-overlay'
      role='region'
      aria-labelledby='no-contracts-title'
    >
      <h3 id='no-contracts-title' role='heading'>{t('ADD_CONTRACT.NO_CONTRACT_ADDED_YET')}</h3>
      <div className='contract-image' role='img' aria-label={t('ADD_CONTRACT.NO_CONTRACT_IMAGE_ALT') || 'No contracts image'}>
        {ContractsImage}
      </div>
      <div className='add-contract-btn-holder'>
        <Button
          type='button'
          className='main-btn'
          size='large'
          variant='contained'
          onClick={() => navigate('/contracts/add-contract')}
          aria-label={String(t('ADD_CONTRACT.ADD_CONTRACT'))}
        >
          {t('ADD_CONTRACT.ADD_CONTRACT')}
        </Button>
      </div>
    </div>
  )
}

export default NoContractOverlay
